import React from "react";
import RequireAuth from "components/auth/RequireAuth";

// Admin Imports
import MainDashboard from "views/admin/default";
import Calendar from "views/admin/calendar";
import Profile from "views/admin/profile";
import MenuOrder from "views/admin/menu-order";
import DataTables from "views/admin/tables";
import LeadProfile from "views/admin/leadProfile";
import StaffManagement from "views/admin/staff-management";
import AddStaffPage from "views/admin/staff-management/pages/AddStaff";
import EditStaffPage from "views/admin/staff-management/pages/EditStaff";
import StaffPermissionsPage from "views/admin/staff-management/pages/StaffPermissions";

import ClientTables from "views/admin/clientTables";
import ClientProfile from "views/admin/clientProfile";
import CareOfManagement from "views/admin/careOfManagement";
import CareOfProfile from "views/admin/careOfProfile";
import FoldersContent from "views/admin/folders/FoldersContent";
import FolderDetail from "views/admin/folders/Detail";
import Configuration from "views/admin/configuration";
import WhatsAppCommunication from "views/admin/whatsapp-communication";
import UserManual from "views/admin/userManual";

// Auth Imports
import SignIn from "views/auth/SignIn";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdGroups,
  MdCalendarToday,
  MdAdminPanelSettings,
  MdLocalHospital,
  MdAssignment,
  MdBusinessCenter,
  MdSwapHoriz,
  MdSettings,
  MdMessage,
  MdMenuBook,
} from "react-icons/md";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <RequireAuth><MainDashboard /></RequireAuth>,
  },
  {
    name: "Calendar",
    layout: "/admin",
    path: "calendar",
    icon: <MdCalendarToday className="h-6 w-6" />,
    component: <RequireAuth><Calendar /></RequireAuth>,
  },
  {
    name: "CareOf Management",
    layout: "/admin",
    path: "careof-management",
    icon: <MdLocalHospital className="h-6 w-6" />,
    component: <RequireAuth><CareOfManagement /></RequireAuth>,
  },
  {
    name: "CareOf Profile",
    layout: "/admin",
    path: "careof-management/profile/:careOfId",
    component: <RequireAuth><CareOfProfile /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Lead Management",
    layout: "/admin",
    path: "lead-management",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <RequireAuth><DataTables /></RequireAuth>,
    secondary: true,
  },
  {
    name: "Data Tables",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "lead-management",
    component: <RequireAuth><DataTables /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Client Management",
    layout: "/admin",
    path: "client-management",
    icon: <MdGroups className="h-6 w-6" />,
    component: <RequireAuth><ClientTables /></RequireAuth>,
    secondary: true,
  },
  {
    name: "Client Details",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "client-management",
    component: <RequireAuth><ClientTables /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Client Profile",
    layout: "/admin",
    path: "client-management/client-profile/:clientId",
    component: <RequireAuth><ClientProfile /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Lead Profile",
    layout: "/admin",
    path: "lead-management/lead-profile/:leadId",
    component: <RequireAuth><LeadProfile /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Lead Folders",
    layout: "/admin",
    path: "folders/leads",
    icon: <MdAssignment className="h-6 w-6" />,
    component: <RequireAuth><FoldersContent /></RequireAuth>,
  },
  {
    name: "Client Folders",
    layout: "/admin",
    path: "folders/clients",
    icon: <MdBusinessCenter className="h-6 w-6" />,
    component: <RequireAuth><FoldersContent /></RequireAuth>,
  },
  {
    name: "Staff List",
    layout: "/admin",
    path: "staff-management",
    component: <RequireAuth><StaffManagement /></RequireAuth>,
    hidden: true,
  },
  /*
  {
    name: "Configuration",
    layout: "/admin",
    path: "configuration",
    icon: <MdSettings className="h-6 w-6" />,
    component: <RequireAuth><Configuration /></RequireAuth>,
  },
  {
    name: "WhatsApp Communication",
    layout: "/admin",
    path: "whatsapp-communication",
    icon: <MdMessage className="h-6 w-6" />,
    component: <RequireAuth><WhatsAppCommunication /></RequireAuth>,
  },
  */
  {
    name: "Folder Detail",
    layout: "/admin",
    path: "folders/:type/:folderId",
    component: <RequireAuth><FolderDetail /></RequireAuth>,
    hidden: true,
  },
  {
    name: "User Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <RequireAuth><Profile /></RequireAuth>,
  },
  /*
  {
    name: "Configuration",
    layout: "/admin",
    path: "configuration",
    icon: <MdSettings className="h-6 w-6" />,
    component: <RequireAuth><Configuration /></RequireAuth>,
  },
  */
  {
    name: "Menu order",
    layout: "/admin",
    path: "menu-order",
    icon: <MdSwapHoriz className="h-6 w-6" />,
    excludeFromMenuOrder: true,
    component: <RequireAuth><MenuOrder /></RequireAuth>,
  },
  {
    name: "Staff Management",
    layout: "/admin",
    path: "staff-management",
    icon: <MdAdminPanelSettings className="h-6 w-6" />,
    component: <RequireAuth><StaffManagement /></RequireAuth>,
  },
  {
    name: "Add Staff",
    layout: "/admin",
    path: "staff-management/add",
    component: <RequireAuth><AddStaffPage /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Edit Staff",
    layout: "/admin",
    path: "staff-management/edit/:staffId",
    component: <RequireAuth><EditStaffPage /></RequireAuth>,
    hidden: true,
  },
  {
    name: "Staff Permissions",
    layout: "/admin",
    path: "staff-management/permissions/:staffId",
    component: <RequireAuth><StaffPermissionsPage /></RequireAuth>,
    hidden: true,
  },
  {
    name: "User Manual",
    layout: "/admin",
    path: "user-manual",
    icon: <MdMenuBook className="h-6 w-6" />,
    component: <RequireAuth><UserManual /></RequireAuth>,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
    hidden: true,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword />,
    hidden: true,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "reset-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
    hidden: true,
  },
];
export default routes;
